import jssVariables from "../../jss_setup";

export const searchStripActivities = {
  searchStripContent: {
    background: "#e8eff2",
    smallscreen: {
      background: "#e8eff2",
    },
  },
  destinationText: {
    borderRadius: 0,
  },
  datesText: {
    borderRadius: 0,
  },
  paxText: {
    borderRadius: 0,
  },
  btns: {
    background: "#e8eff2",
    paddingTop: jssVariables.half_gap,
  },
};

export const activityStyles = {
  category: {
    background: "#9D9D9D",
  },
  title: {
    fontSize: "medium",
  },
  priceTxt: {
    fontWeight: 600,
  },
  priceValue: {
    fontWeight: 700,
    fontSize: "x-large",
    smallscreen: {
      fontSize: "large",
    },
    bigscreen: {
      fontSize: "x-large",
    },
  },
  viewBtnStyles: {},
};

export const actRating = {
  iconFilled: {
    fontSize: "medium",
    color: "black",
  },
  iconEmpty: {
    fontSize: "medium",
    color: "black",
  },
};

export const activityDetailsStyles = {
  title: {
    fontSize: "x-large",
    fontWeight: 800,
  },
  location: {
    display: "grid",
    gridTemplateColumns: "repeat(2, max-content)",
    gridGap: jssVariables.half_gap,
  },
  locationMapIconContainer: {
    display: "block",
    smallscreen: {
      cursor: "default",
    },
  },
  locationText: {
    fontWEight: 700,
  },
};

export const actInfoStyles = {
  icon: {
    background: jssVariables.colors.secondary_color,
  },
};

export const ActSchedulesModal = {
  priceComponentTotal: {
    priceComponent: {
      fontSize: "x-large",
      fontWeight: 800,
    },
  },
};

export const activityDetailsDescription = {
  btnStyles: {
    ButtonDefault: {
      width: "100%",
    },
  },
};

export const ActPreBook = {
  img: {
    width: "70%",
  },
  priceComponent: {
    priceComponent: {
      fontWeight: 800,
      color: jssVariables.colors.base_color,
      fontSize: "x-large",
    },
  },
};

export const ActPriceSearchForm = {
  underlay: {
    backdropFilter: "blur(15px)",
  },
  ActPriceSearchForm: {
    justifyContent: "center",
    justifyItems: "center",
  },
  priceContr: {
    fontWeight: 600,
  },
  priceComponent: {
    fontSize: "x-large",
    fontWeight: 800,
    color: jssVariables.colors.base_color,
  },
  inputGroup: {
    gridTemplateColumns: "repeat(2, max-content)",
    gridGap: jssVariables.half_gap,
    alignItems: "center",
    padding: [0, jssVariables.half_gap],
  },
  label: {
    fontWeight: 600,
    fontSize: "small",
  },
  datepicker: {
    width: "8rem",
    borderRadius: 0,
    borderColor: "#D2D2D2",
  },
};
